// extracted by mini-css-extract-plugin
module.exports = {"btn":"styles_btn__1QfEO","secondary":"styles_secondary__wBKpm styles_btn__1QfEO","disabled":"styles_disabled__38A_o"};